import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonDays,
  ButtonStyled,
  HeadingStyled,
  HeadingStyledLg,
  HeadingStyledMd,
  HeadingStyledSm,
} from "../../styled/Elements";
import {
  BackwardArrow,
  CalendarIcon,
  ChatIcon,
  FocusEye,
  ForwardArrow,
  SearchPropIcon,
} from "../../styled/AllImages";
import { InquiryStatsBannerWrapper } from "./styles";
import { useNavigate } from "react-router-dom";

const InquiryStatsBanner = ({user}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate()
  return (
    <InquiryStatsBannerWrapper>
      <Box className="InquiryStatsBannerContent">
        <Box className="stats-box">
          <Box className="stat-icon">
            <FocusEye />
          </Box>
          <Box>
            <HeadingStyledMd color="var(--white)" size="20px">
              {t("profile_visits")}
            </HeadingStyledMd>
            <HeadingStyledLg color="var(--white)" size="24px">
            {user?.number_of_profile_views || 0}
            </HeadingStyledLg>
          </Box>
        </Box>
        <Box className="stats-box mt-3">
          <Box className="stat-icon">
            <ChatIcon />
          </Box>
          <Box>
            <HeadingStyledMd color="var(--white)" size="20px">
              {t("inquiries_received")}
            </HeadingStyledMd>
            <HeadingStyledLg color="var(--white)" size="24px">
              {user?.number_of_requests || 0}
            </HeadingStyledLg>
          </Box>
        </Box>
        {/* <Box className="stats-box mt-3">
          <Box className="stat-icon">
            <CalendarIcon width={28} height={28} />
          </Box>
          <Box>
            <HeadingStyledMd color="var(--white)" size="20px">
              {t("scheduled_visits")}
            </HeadingStyledMd>
            <HeadingStyledLg color="var(--white)" size="24px">
              {0}
            </HeadingStyledLg>
          </Box>
        </Box> */}
        <Box className="mt-4">
          <ButtonStyled
            iconAfter={language === "en" ? BackwardArrow : ForwardArrow}
            bg={"var(--bgNew)"}
            color={"var(--themeColorSecondary)"}
            label={t("view_all_inquiries")}
            className="mt-3 mt-lg-0 w-100 py-4"
            clName="w-100"
            onClick={() => navigate("/inquiry-list")}
          />
          {/* <ButtonStyled
            iconAfter={language === "en" ? BackwardArrow : ForwardArrow}
            bg={"var(--bgNew)"}
            color={"var(--themeColorSecondary)"}
            label={t("view_scheduled_visits")}
            className="mt-2 w-100 py-4"
            clName="w-100"
            // onClick={() => navigate("/scheduled-visits")}
          /> */}
        </Box>
      </Box>
    </InquiryStatsBannerWrapper>
  );
};

export default InquiryStatsBanner;
